import {rootAPIUrl} from '__utils/constants'

//Billing application
export const billingFetchURL = rootAPIUrl + "/payments/";

//Billing download
export const billingDownloadURL =  rootAPIUrl + "/payments/download/{id}/";